<template>
    <div class="content">
        <section>
            <div class="content-box">
                <HeaderBg :title="'Statistic'" :sub_title="'Statistic'" :desc="''" />

                <div class="text-center mt-5">
                    <div class="d-flex justify-content-center gap-2 mb-4">
                        <button v-for="option in ['3D', '4D', '5D']" :key="option" class="btn text-white"
                            :class="{ 'bg-dark': selectedType !== option, 'btn-primary': selectedType === option }"
                            @click="selectType(option)" style="min-width: 60px;">
                            {{ option }}
                        </button>
                    </div>
                </div>

                <!-- Draw Period Picker -->
                <div class="bg-dark m-2 m-md-0 text-white p-4 rounded my-4 justify-content-center align-items-center gap-3"
                    style="background-color: #1E3378!important;">
                    <h6>SELECT DRAW PERIOD</h6>
                    <div class="d-flex align-items-center gap-2">
                        <select class="form-select" v-model="yearFrom" @change="fetchData">
                            <option v-for="year in years" :key="'yf' + year" :value="year">{{ year }}</option>
                        </select>
                        <select class="form-select" v-model="monthFrom" @change="fetchData">
                            <option v-for="(month, index) in months" :key="'mf' + index" :value="index + 1">{{ month }}
                            </option>
                        </select>
                        <span>to</span>
                        <select class="form-select" v-model="yearTo" @change="fetchData">
                            <option v-for="year in years" :key="'yt' + year" :value="year">{{ year }}</option>
                        </select>
                        <select class="form-select" v-model="monthTo" @change="fetchData">
                            <option v-for="(month, index) in months" :key="'mt' + index" :value="index + 1">{{ month }}
                            </option>
                        </select>
                    </div>
                </div>

                <!-- Frequency Table -->
                <div class="d-flex justify-content-center">
                    <div class="text-center">
                        <h6 class="fw-bold mb-3 mt-3">EUROPE LOTTO {{ selectedType }} Number Frequency Table</h6>
                        <div class="d-flex flex-wrap justify-content-center gap-3">
                            <div v-for="n in 10" :key="n" class="d-flex flex-column align-items-center"
                                style="width: 15%;">
                                <div class="number-circle">{{ n % 10 }}</div>
                                <div class="mt-1 frequency-box" style="width: 60px;">{{ frequencies[n % 10] ?? 0 }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
import HeaderBg from './components/HeaderBg.vue';
import api from '@/axios'

export default {
    name: 'StatisticPage',
    components: { HeaderBg },
    data() {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();
        return {
            selectedType: '3D',
            yearFrom: currentYear,
            yearTo: currentYear,
            monthFrom: 1,
            monthTo: currentMonth + 1,
            frequencies: {},
            years: Array.from({ length: 5 }, (_, i) => currentYear - i),
            months: [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ],
        };
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        selectType(type) {
            this.selectedType = type;
            this.fetchData();
        },
        async fetchData() {
            try {
                const res = await api.get('/statistics', {
                    params: {
                        year_from: this.yearFrom,
                        month_from: this.monthFrom,
                        year_to: this.yearTo,
                        month_to: this.monthTo,
                        type: this.selectedType
                    }
                });
                this.frequencies = res.data?.frequencies ?? {};
            } catch (error) {
                console.error('Error fetching statistics:', error);
            }
        }
    }
};
</script>

<style scoped>
.number-circle {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #001F54;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 18px;
}

.frequency-box {
    background-color: white;
    padding: 4px 10px;
    border-radius: 6px;
    border: 1px solid #ccc;
    font-weight: bold;
}
</style>
